import type { ReactNode } from "react";
import { getThemeIconComponent } from "../theme/runtime/theme-icons";

const FALLBACK_EXTENSION_ACTIVITY_ICON = "Puzzle";

export function extensionActivityIconName(_extensionId: string): string {
    return FALLBACK_EXTENSION_ACTIVITY_ICON;
}

export function createExtensionActivityIcon(
    extensionId: string,
    size = 18,
): ReactNode {
    const iconName = extensionActivityIconName(extensionId);
    const Icon = getThemeIconComponent(iconName, "BotMessageSquare");
    return <Icon size={size} data-extension-activity-icon={iconName} />;
}

function hasProvidedIcon(icon: ReactNode): boolean {
    return (
        icon !== undefined &&
        icon !== null &&
        icon !== false &&
        typeof icon !== "string"
    );
}

export function renderExtensionActivityIcon(
    extensionId: string,
    icon: ReactNode,
    fallbackSize = 18,
): ReactNode {
    if (hasProvidedIcon(icon)) return icon;
    return createExtensionActivityIcon(extensionId, fallbackSize);
}
